import React from "react";
import Paper from "../../../../mui/core/Paper";
import { BWGridAPI, GridHeader, GridTable } from "../../../../ui/BWGrid";
import AddCircle from "@material-ui/icons/AddCircle";
import Cancel from "@material-ui/icons/Cancel";
import Edit from "@material-ui/icons/Edit";
import TemplateCategory from "../../../../../models/TemplateCategory";
import PropTypes from "prop-types";
import useUserRole from "../../../../hooks/useUserRole";
import { isSuperAdmin } from "../../../../../utils/roleUtils";

const baseColumns = ["name"];

export const getColumns = userRole => {
  const columns = [...baseColumns];
  if (isSuperAdmin(userRole)) {
    columns.push("scope.id");
  }
  return columns;
};

export const getColumnOptions = scopes => ({
  name: { bold: true, filter: true, fill: true },
  "scope.id": {
    title: "Scope",
    filter: "select",
    render: ({ scope }) => scope?.name,
    filterOptions: {
      options: scopes,
    },
  },
});

const getRowMenu = (onOpenEditModal, onOpenDeleteModal) => {
  return [
    {
      icon: <Edit />,
      text: "Edit",
      onClick: onOpenEditModal,
    },
    { icon: <Cancel />, text: "Delete", onClick: onOpenDeleteModal },
  ];
};

const TemplateCategoryPage = ({
  dataComponent,
  scopes,
  onOpenCreateModal,
  onOpenEditModal,
  onOpenDeleteModal,
}) => {
  const userRole = useUserRole();

  return (
    <Paper>
      <BWGridAPI
        dataComponent={dataComponent}
        model={TemplateCategory}
        includes={["scope"]}
        apiRoute="template-categories"
        defaultSorting={[{ columnName: "name", direction: "asc" }]}
      >
        <GridHeader
          headerText={`${dataComponent.totalRows} Template Categories`}
          actions={[
            {
              text: "CREATE TEMPLATE CATEGORY",
              icon: <AddCircle />,
              handler: onOpenCreateModal,
            },
          ]}
        />
        <GridTable
          columns={getColumns(userRole)}
          columnOptions={getColumnOptions(scopes)}
          rowMenu={getRowMenu(onOpenEditModal, onOpenDeleteModal)}
        />
      </BWGridAPI>
    </Paper>
  );
};

TemplateCategoryPage.propTypes = {
  dataComponent: PropTypes.object.isRequired,
  scopes: PropTypes.array,
  onOpenCreateModal: PropTypes.func.isRequired,
  onOpenEditModal: PropTypes.func.isRequired,
  onOpenDeleteModal: PropTypes.func.isRequired,
};

export default TemplateCategoryPage;
